import { useState } from "react";
import { X, Download } from "lucide-react";

/**
 * PhotoLightbox — clickable thumbnail that opens a fullscreen image viewer.
 * Usage: <ClickablePhoto src={url} alt="..." className="h-10 w-10" />
 */
export const ClickablePhoto = ({ src, alt = "photo", className = "h-10 w-10", testid }) => {
  const [open, setOpen] = useState(false);
  if (!src) return null;
  return (
    <>
      <img
        src={src}
        alt={alt}
        className={`${className} rounded object-cover border cursor-zoom-in hover:opacity-80 transition`}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        data-testid={testid}
      />
      {open && (
        <div
          className="fixed inset-0 z-[9999] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
          data-testid={testid ? `${testid}-lightbox` : "photo-lightbox"}
        >
          <button
            className="absolute top-4 right-4 text-white bg-slate-900/60 hover:bg-slate-900 rounded-full p-2"
            onClick={(e) => { e.stopPropagation(); setOpen(false); }}
            aria-label="Fermer"
          >
            <X className="w-6 h-6" />
          </button>
          <a
            href={src}
            download
            onClick={(e) => e.stopPropagation()}
            className="absolute top-4 right-16 text-white bg-slate-900/60 hover:bg-slate-900 rounded-full p-2"
            aria-label="Télécharger"
          >
            <Download className="w-5 h-5" />
          </a>
          <img
            src={src}
            alt={alt}
            className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};
